import { TTBackboneView } from '@/views/TTBackboneView';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import 'bootstrap';

export class PortalForgotPasswordController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {
			events: {
				'click .send-reset-email': 'sendResetEmail',
				'click .close-reset-email': 'closeResetEmail',
				'submit .forgot-password-reset-form': 'sendResetEmail'
			}
		} );

		super( options );
	}

	initialize( options ) {
		super.initialize( options );
		this.api = TTAPI.APIRecruitmentAuthentication;
		this.render_in_signin_modal = options && options.render_in_signin_modal === true;
		var el = Global.loadWidget( 'views/portal/sign_in/PortalForgotPassword.html' );
		this.setElement( _.template( el )() );
		this.normalizeModalMarkup();
		if ( this.render_in_signin_modal ) {
			this.renderInSignInModal();
		} else {
			this.emailInput = this.$( '#email' );
			this.render();
		}
	}

	normalizeModalMarkup() {
		this.$el.addClass( 'portal-auth-modal' );
		this.$( '.modal-dialog' ).removeClass( 'modal-sm' ).addClass( 'modal-dialog-centered' );

		if ( this.$( '#forgotPasswordModalBody .portal-auth' ).length === 0 ) {
			this.$( '#forgotPasswordModalBody' ).html(
				'<div class="portal-auth portal-auth-no-icons">' +
					'<form class="forgot-password-reset-form portal-auth-form" autocomplete="on">' +
						'<div class="form-group portal-auth-field">' +
							'<label for="email">' + $.i18n._( 'Email' ) + '</label>' +
							'<div class="portal-auth-input-wrap">' +
								'<input type="email" class="form-control" id="email" autocomplete="email">' +
							'</div>' +
						'</div>' +
					'</form>' +
				'</div>'
			);
		}

		this.$( '#forgotPasswordModalBody .portal-auth' ).addClass( 'portal-auth-no-icons' );
		this.$( '#forgotPasswordModalBody .portal-auth-visual, #forgotPasswordModalBody .portal-auth-input-icon' ).remove();

		this.$( '#email' ).attr( {
			type: 'email',
			autocomplete: 'email'
		} ).addClass( 'form-control' );

		this.$( '#forgotPasswordModalFooter .close-reset-email' )
				.removeClass( 'btn-primary btn-default' )
				.addClass( 'btn portal-modal-secondary portal-modal-cancel' )
				.attr( 'data-bs-dismiss', 'modal' )
				.removeAttr( 'data-dismiss' );

		this.$( '#forgotPasswordModalFooter .send-reset-email' )
				.removeClass( 'btn-default' )
				.addClass( 'btn portal-modal-primary' );
	}

	render() {
		var $this = this;
		this.emailInput.unbind( 'keydown' ).bind( 'keydown', function( e ) {
			if ( e.keyCode === 13 ) {
				e.preventDefault();
				$this.sendResetEmail();
			}
		} );
		$( 'body' ).append( this.$el );
		const modal = new bootstrap.Modal( this.$el[0], {
			backdrop: 'static'
		} );

		this.$el.one( 'shown.bs.modal', function() {
			$this.emailInput.trigger( 'focus' );
		} );
		modal.show();
	}

	// Render into the existing Sign In modal so the backdrop stays stable during auth modal handoffs.
	renderInSignInModal() {
		var $this = this;
		var signin_modal = $( '#signinModal' );

		signin_modal.find( '#signinModalLabel' ).text( this.$( '#forgotPasswordModalLabel' ).text() );
		signin_modal.find( '#signinModalBody' ).html( this.$( '#forgotPasswordModalBody' ).html() );
		signin_modal.find( '#signinModalFooter' ).html( this.$( '#forgotPasswordModalFooter' ).html() );

		this.setElement( signin_modal );
		this.emailInput = this.$( '#email' );
		this.emailInput.unbind( 'keydown' ).bind( 'keydown', function( e ) {
			if ( e.keyCode === 13 ) {
				e.preventDefault();
				$this.sendResetEmail();
			}
		} );
		this.emailInput.trigger( 'focus' );
	}

	sendResetEmail( e ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
		var $this = this;
		var email = this.emailInput.val();
		this.api.resetPassword( email, {
			onResult: function( result ) {
				if ( !result.isValid() ) {
					$this.showErrorAlert( result );
				} else {
					var response = result.getResult();
					if ( response.hasOwnProperty( 'email_sent' ) ) { // make sure email if is sent successfully
						bootstrap.Modal.getInstance( $this.$el[0] ).hide();
						IndexViewController.instance.router.showTipModal( $.i18n._( 'An email has been sent to you with instructions on how to reset your password.' ) );
					}
				}
			}
		} );
	}

	closeResetEmail() {
		bootstrap.Modal.getInstance( this.$el[0] ).hide();
	}

	showErrorAlert( result ) {
		var details = result.getDetails();
		// if ( details.hasOwnProperty( 'error' ) ) {
		//
		// }
		if ( !details ) {
			details = result.getDescription(); // If the details is empty, try to get description to show.
		}
		var error_string = '';

		if ( Global.isArray( details ) || typeof details === 'object' ) {

			$.each( details, function( index, val ) {

				if ( val.hasOwnProperty( 'error' ) ) {
					val = val.error;
				}
				var i = 0;
				for ( var key in val ) {
					error_string = error_string + val[key];
					if ( i > 0 ) {
						error_string += '<br>';
					}
					i++;
				}
			} );
		} else {
			error_string = details;
		}
		this.emailInput.css( 'border', '1px solid red' );
		const tooltip = new bootstrap.Tooltip( this.emailInput[0], {
			title: error_string
		} );

		tooltip.show();
	}

}
